import { boardService } from '../../../services/board.service.js';
import { publicFormService } from '../../../services/public-form.service.js';

import { imageService } from '../../../services/image.service.js';
import { utilService } from '../../../services/util.service.js';
import { store } from '../../store.js';
import { cloneDeep } from 'lodash';
import { dispatchMultipleActions } from '../../dispatchHelper.js'
import {
  setBoards,
  setBoard,
  setFilterBoard,
  removeBoard as deleteBoard,
  addBoard,
  updateBoard,
  setModal,
  setFilter as setFilterAction,
  setDynamicModal,
  setDynamicWidth as setWidth,
  setSelectedBoardId,
  toggleGroupCollapse,
  clearBoards,
  setGroupCollapseState,
  setBoardsLoading,
  setBoardModalRoute,
  clearBoardModalRoute,
  clearFilterDynamic
} from '../reducers/board.reducer.js';
import {
  setSelectedDesktop,
  setDesktops
} from '../../desktop/reducers/desktop.reducer.js'
import { setGroups } from '../../group/reducers/group.reducer.js';
import { clearAllGroupTasks, moveTaskBetweenGroupsOptimistic, setTasks, updateGroupTask, removeTasksFromStore } from '../../task/reducers/task.reducer.js';
import { updateGroup as updateGroupReducer } from '../../group/reducers/group.reducer.js';

import { setLoading } from '../../user/reducers/auth.reducer.js';
import { updateGroup } from '../../group/actions/group.actions.js';
import { updateTaskInGroup } from '../../task/actions/task.actions.js';
import { groupService } from '../../../services/group.service.js';
import { loadDashboard } from '../../dashboard/actions/dashboard.actions.js';
import { clearNotification } from '../../notifications/actions/notifications.actions.js';
import { taskService } from '../../../services/task.service.js';

const dispatch = store.dispatch

export async function createBoard(obj, desktops) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    const data = await boardService.addBoard(obj, accountId);

    const updatedDesktop = data?.updatedDesktop || null;
    const newBoard = data?.newBoard || null;

    if (updatedDesktop) {
      const updatedDesktops = utilService.updateItemInList(desktops, updatedDesktop);

      dispatchMultipleActions(
        setSelectedDesktop({ selectedDesktop: updatedDesktop }),
        setDesktops(updatedDesktops)
      );
    }

    if (newBoard?._id) {
      dispatchMultipleActions(
        setBoard({ board: newBoard }),
        setFilterBoard({ filteredBoard: newBoard })
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
}

export async function createFolder(obj, desktops) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    const data = await boardService.addFolder(obj, accountId);

    const updatedDesktop = data?.updatedDesktop || data?.desktop || null;

    if (updatedDesktop) {
      const updatedDesktops = utilService.updateItemInList(desktops, updatedDesktop);

      dispatchMultipleActions(
        setSelectedDesktop({ selectedDesktop: updatedDesktop }),
        setDesktops(updatedDesktops)
      );
    }

    return data;
  } catch (err) {
    throw err;
  }
}

export async function toggleCollapseGroup(groupId) {
  dispatch(toggleGroupCollapse(groupId));
}


export async function loadBoards(filterBy) {
  try {
    const boards = await boardService.query(filterBy);
    dispatchMultipleActions(
      setBoards({ boards })
    );
    return boards;
  } catch (err) {
    throw err;
  }
}

export async function loadSocketBoard(filteredBoard, board) {
  try {
    dispatchMultipleActions(setBoard({ board }));
    if (!filteredBoard) dispatchMultipleActions(setFilterBoard({ filteredBoard: board }));
    else dispatchMultipleActions(setFilterBoard({ filteredBoard }));
  } catch (err) {
    throw err;
  }
}

export async function loadBoardsForDesktopSwitch(desktopId, minMs = 800) {
  const t0 = Date.now();

  try {
    dispatch(setBoardsLoading(true));

    const boards = await boardService.query({ desktopId });
    dispatchMultipleActions(
      setBoards({ boards }),
      setFilterBoard({ filteredBoard: null })
    );

    return boards;
  } catch (err) {
    throw err;
  } finally {
    const elapsed = Date.now() - t0;
    const remaining = Math.max(0, minMs - elapsed);
    if (remaining) await new Promise((r) => setTimeout(r, remaining));

    dispatch(setBoardsLoading(false));
  }
}

export async function updateOptimisticBoard(newBoard, prevBoard, filterBy) {
  try {
    // Atualiza o Redux primeiro para feedback instantâneo
    const filteredBoard = boardService.getFilteredBoard(newBoard, filterBy, '', '');

    dispatchMultipleActions(
      setBoard({ board: newBoard }),
      setFilterBoard({ filteredBoard })
    );

    // Aguarda o backend salvar
    await saveBoard(newBoard);
  } catch (err) {
    console.error("Erro ao atualizar board:", err);

    // Se der erro, volta para o estado anterior
    const prevFilteredBoard = boardService.getFilteredBoard(prevBoard, filterBy, '', '');
    dispatchMultipleActions(
      setBoard({ board: prevBoard }),
      setFilterBoard({ filteredBoard: prevFilteredBoard })
    );

    throw err;
  }
}
export async function getBoardById(boardId) {
  try {
    const data = await boardService.getById(boardId);
    return data?.board;
  } catch (err) {
    console.log("Erro ao buscar board:", err);
    throw err;
  }
}

export async function getBoardsById(boardsId, userId) {
  try {
    const data = await boardService.getByIds(boardsId, userId);
    return data;
  } catch (err) {
    console.log("Erro ao buscar board:", err);
    throw err;
  }
}

export async function checkPageNameDuplicate(pageName, boardId) {
  try {
    const exists = await boardService.checkPageFormExists(pageName, boardId);
    return exists;
  } catch (err) {
    console.log('Erro ao verificar duplicidade do pageName:', err);
    throw err;
  }
}


export async function getFormByPageName(pageName) {
  try {
    const data = await publicFormService.getForm(pageName);
    return data;
  } catch (err) {
    console.log("Erro ao buscar board:", err);
    throw err;
  }
}

export function setGroupCollapse(groupId, isOpen) {
  return (dispatch) => {
    dispatch(setGroupCollapseState({ groupId, isOpen }));
  };
}

export async function loadBoard(boardId, filterBy) {
  try {
    dispatch(setLoading(true));
    dispatch(clearAllGroupTasks());

    const data = await boardService.getById(boardId);

    // board.groups deve ser array de IDs (evita duplicar grupos no estado)
    const boardToStore = data?.board
      ? {
        ...data.board,
        groups: Array.isArray(data.board.groups)
          ? data.board.groups
            .map((g) => (typeof g === "string" ? g : g?._id))
            .filter(Boolean)
          : [],
      }
      : data?.board;

    dispatchMultipleActions(
      setBoard({ board: boardToStore }),
      setFilterBoard({ filteredBoard: boardToStore }),
      setGroups({ groups: data?.groups || [] })
    );

    await loadDashboard(data?.board?.dashboardId);
  } catch (err) {
    console.log("Had issues loading", err);
    throw err;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function removeBoard(boardId) {
  try {
    const data = await boardService.remove(boardId);

    // normaliza o id (service pode retornar boardId)
    const removedBoardId = data?.boardId || boardId;

    // remove do store de boards
    dispatchMultipleActions(deleteBoard({ boardId: removedBoardId }));

    // se a board atual for a removida, limpa a tela
    const currentBoardId = store.getState().board?.board?._id;
    if (currentBoardId && String(currentBoardId) === String(removedBoardId)) {
      dispatchMultipleActions(
        clearBoards(),
        setGroups({ groups: [] })
      );
    }

    return data?.board || data;
  } catch (err) {
    console.log("Erro ao remover board:", err);
    throw err;
  }
}


export async function saveBoard(board) {
  const account = store.getState().accounts.selectedAccount.accountId;

  try {
    if (!board?._id) {
      throw new Error("saveBoard() não cria board. Use createBoard().");
    }

    const data = await boardService.save(board, account._id);

    const savedBoardRaw = data?.board || data;

    const savedBoard = savedBoardRaw
      ? {
        ...savedBoardRaw,
        groups: Array.isArray(savedBoardRaw.groups)
          ? savedBoardRaw.groups
            .map((g) => (typeof g === "string" ? g : g?._id))
            .filter(Boolean)
          : [],
      }
      : savedBoardRaw;

    store.dispatch(updateBoard({ board: savedBoard }));
    dispatchMultipleActions(
      setBoard({ board: savedBoard }),
      setFilterBoard({ filteredBoard: savedBoard })
    );

    return savedBoard;
  } catch (err) {
    console.error("Cant save board:", err);

    const message =
      err?.response?.data?.message ||
      err?.message ||
      "Erro ao salvar board.";

    const nextError = new Error(message);
    nextError.originalError = err;
    nextError.response = err?.response;
    nextError.cycle = err?.response?.data?.cycle || null;
    nextError.componentId = err?.response?.data?.componentId || null;

    throw nextError;
  }
}

export async function addAutomation(boardId, payload) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    const data = await boardService.addAutomationBoard(boardId, accountId, payload);
    return data.message;
  } catch (err) {
    console.error("Cant create automation:", err);
    throw err;
  }
}

export async function getAutomation(boardId) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    const data = await boardService.getAutomationByBoardId(boardId, accountId);

    return data;
  } catch (err) {
    console.error("Cant create automation:", err);
    throw err;
  }
}

export async function deleteAutomation(boardId, automationId) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;
    const userId = store.getState().auth?.currentUser?._id;

    const savedBoard = await boardService.deleteAutomationBoard(boardId, accountId, automationId, userId);

    return savedBoard;
  } catch (err) {
    console.error("Cant delete automation:", err);
    throw err;
  }
}

export async function setAutomationGroupPause(boardId, automationId, groupId, paused) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    return await boardService.setAutomationGroupPause(
      boardId,
      accountId,
      automationId,
      { groupId, paused }
    );
  } catch (err) {
    console.error("Cant update automation group pause:", err);
    throw err;
  }
}


export async function updatePickerCmpsOrder(filteredBoard, cmpsOrders) {
  const { board } = store.getState().board;

  const prevBoard = cloneDeep(board);
  const prevFilteredBoard = cloneDeep(filteredBoard);

  try {
    const updatedBoard = cloneDeep(board);
    const updatedFilteredBoard = cloneDeep(filteredBoard);

    updatedBoard.cmpsOrder = cmpsOrders;
    updatedFilteredBoard.cmpsOrder = cmpsOrders;

    dispatchMultipleActions(
      setBoard({ board: updatedBoard }),
      setFilterBoard({ filteredBoard: updatedFilteredBoard })
    );

    await saveBoard(updatedBoard);
  } catch (err) {
    dispatchMultipleActions(
      setBoard({ board: prevBoard }),
      setFilterBoard({ filteredBoard: prevFilteredBoard })
    );

    throw err;
  }
}

export async function duplicateGroup(filteredBoard, group) {
  try {
    const { board } = store.getState().board;
    const clonedBoard = cloneDeep(board);
    const duplicatedGroup = cloneDeep(group);
    duplicatedGroup.title += ' (copy)';
    delete duplicatedGroup._id
    const idx = clonedBoard.groups.findIndex((g) => {
      const id = typeof g === "string" ? g : g?._id;
      return id === group._id;
    });
    if (idx === -1) throw new Error("Group not found in board.groups");
    clonedBoard.groups.splice(idx + 1, 0, duplicatedGroup);
    const returnedBoard = await saveBoard(clonedBoard);
    dispatchMultipleActions(setBoard({ board: returnedBoard }), setFilterBoard({ filteredBoard }));
  } catch (err) {
    throw err;
  }
}

export async function removeGroup(boardId, groupId, filteredBoard) {
  try {
    const data = await boardService.removeGroup(boardId, groupId);
    const returnedBoard = data?.board || data;

    const boardToStore = returnedBoard
      ? {
        ...returnedBoard,
        groups: Array.isArray(returnedBoard.groups)
          ? returnedBoard.groups
            .map((g) => (typeof g === "string" ? g : g?._id))
            .filter(Boolean)
          : [],
      }
      : returnedBoard;

    dispatchMultipleActions(
      setBoard({ board: boardToStore }),
      setFilterBoard({ filteredBoard: boardToStore })
    );

    return boardToStore;
  } catch (err) {
    throw err;
  }
}

export async function duplicateTask(filteredBoard, group, task) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;
    const boardId = filteredBoard?._id || store.getState().board.board?._id;
    if (!boardId) throw new Error("boardId não encontrado para duplicar task");
    if (!group?._id) throw new Error("groupId não informado para duplicar task");
    if (!task?._id) throw new Error("taskId não informado para duplicar task");

    const { task: duplicatedTask, group: updatedGroup } =
      await taskService.duplicateTask(accountId, boardId, group._id, task._id);

    if (updatedGroup) dispatch(updateGroupReducer({ group: updatedGroup }));
    if (duplicatedTask) dispatch(updateGroupTask({ task: duplicatedTask }));

    const { board } = store.getState().board;
    dispatchMultipleActions(setBoard({ board }), setFilterBoard({ filteredBoard: board }));

    return duplicatedTask;
  } catch (err) {
    console.error("Failed to duplicate task:", err);
    throw err;
  }
}

export async function addTask(task, group, filteredBoard, activity) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;
    const boardId = filteredBoard?._id || store.getState().board.board?._id;

    if (!boardId) throw new Error("boardId não encontrado para criar task");
    if (!group?._id) throw new Error("groupId não informado para criar task");

    const { task: createdTask, group: updatedGroup } = await taskService.createTask(
      accountId,
      boardId,
      group._id,
      task
    );

    if (activity && createdTask?._id) {
      activity.task = { id: createdTask._id, title: createdTask.title };
    }

    if (updatedGroup) {
      dispatch(updateGroupReducer({ group: updatedGroup }));
    } else {
      // fallback caso o backend retorne só a task
      const prevGroup = store.getState().groups.groups.find((g) => g?._id === group._id);
      if (prevGroup) {
        const nextGroup = cloneDeep(prevGroup);
        nextGroup.tasks = Array.isArray(nextGroup.tasks) ? nextGroup.tasks : [];
        nextGroup.tasks.push(createdTask._id);
        dispatch(updateGroupReducer({ group: nextGroup }));
      }
    }

    if (createdTask) {
      dispatch(updateGroupTask({ task: createdTask }));
    }

    const { board } = store.getState().board;
    dispatchMultipleActions(
      setBoard({ board }),
      setFilterBoard({ filteredBoard: board })
    );

    return createdTask;
  } catch (err) {
    console.error("Failed to add task:", err);
    throw err;
  }
}

export function toggleModal(isOpenModal) {
  if (!isOpenModal === false) {
    clearNotification();
  }
  dispatchMultipleActions(setModal({ isOpen: !isOpenModal }));
}

export async function updateGroups(group, filteredBoard) {
  try {
    const updatedGroup = await boardService.updateGroup(filteredBoard._id, group);
    dispatch(updateGroupReducer({ group: updatedGroup }));
    return updatedGroup;
  } catch (err) {
    throw err;
  }
}

export async function updateModalBoard(modalRoute) {
  try {
    dispatch(setBoardModalRoute(modalRoute));
    return;
  } catch (err) {
    throw err;
  }
}


export async function clearModalBoard() {
  try {
    dispatch(clearBoardModalRoute());
    return;
  } catch (err) {
    throw err;
  }
}

export async function updateGroupAction(filteredBoard, saveGroup) {
  try {
    const updatedGroup = await boardService.updateGroup(filteredBoard._id, saveGroup);
    dispatch(updateGroupReducer({ group: updatedGroup }));
    return updatedGroup;
  } catch (err) {
    throw err;
  }
}

export async function deactivateTask(boardId, groupId, selectedTasks) {
  try {
    const taskIds = selectedTasks.map(task =>
      (typeof task === 'object' && task !== null) ? task._id : task
    );
    const user = store.getState().auth?.currentUser;
    const accountId = store.getState().accounts.selectedAccount.accountId._id;

    const data = await boardService.deactivateTasks(
      taskIds,
      boardId,
      groupId,
      user,
      accountId
    );

    if (data.group) dispatch(updateGroupReducer({ group: data.group }));

    if (Array.isArray(data.deactivatedTaskIds) && data.deactivatedTaskIds.length) {
      dispatch(removeTasksFromStore({ groupId, taskIds: data.deactivatedTaskIds }));
    } else {
      dispatch(removeTasksFromStore({ groupId, taskIds }));
    }
  } catch (err) {
    console.error("Erro na action deactivateTasksAndUpdateGroup:", err);
    throw err;
  }
}

export async function updateTaskAction(filteredBoard, groupId, saveTask, activity, files = []) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id;
    const boardId = filteredBoard?._id || store.getState().board.board?._id;
    if (!boardId) throw new Error("boardId não encontrado para atualizar task");
    if (!groupId) throw new Error("groupId não informado para atualizar task");
    if (!saveTask?._id) throw new Error("taskId não informado para atualizar task");

    const { task: updatedTask, group: updatedGroup } = await taskService.updateTask(
      accountId,
      boardId,
      groupId,
      saveTask
    );

    if (files?.length) {
      await taskService.uploadTaskFile(accountId, boardId, groupId, updatedTask._id, files);
    }

    if (updatedGroup) dispatch(updateGroupReducer({ group: updatedGroup }));
    if (updatedTask) dispatch(updateGroupTask({ task: updatedTask }));

    return updatedTask;
  } catch (err) {
    throw err;
  }
}


export async function removeTask(boardId, groupId, taskId, filteredBoard) {
  try {
    const returnedBoard = await boardService.removeTask(boardId, groupId, taskId);
    dispatchMultipleActions(setBoard({ board: returnedBoard }), setFilterBoard({ filteredBoard }));
  } catch (err) {
    throw err;
  }
}

export async function updateChoicePreRegistration(boardId, columnId, accountId, payload) {
  try {
    const data = await boardService.choicePreRegistration(boardId, columnId, accountId, payload);
    dispatchMultipleActions(setBoard({ board: data?.board }));
  } catch (err) {
    throw err;
  }
}


export async function updateCmps(prevBoard, newBoard, cmp, isResize) {
  try {
    if (!isResize) {
      dispatch(setLoading(true));
    }

    const accountId = store.getState().accounts.selectedAccount.accountId._id;
    await boardService.updateOrder(prevBoard._id, cmp, accountId);

    dispatchMultipleActions(
      setBoard({ board: newBoard })
    );
  } catch (err) {
    dispatchMultipleActions(
      setBoard({ board: prevBoard })
    );

    const message =
      err?.response?.data?.message ||
      err?.message ||
      "Erro ao atualizar coluna.";

    const nextError = new Error(message);
    nextError.originalError = err;
    nextError.response = err?.response;
    nextError.cycle = err?.response?.data?.cycle || null;
    nextError.componentId = err?.response?.data?.componentId || null;

    throw nextError;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function deleteCmps(prevBoard, newBoard, cmp) {
  try {
    dispatch(setLoading(true));

    const accountId = store.getState().accounts.selectedAccount.accountId._id;
    const data = await boardService.deleteOrder(prevBoard._id, cmp, accountId);
    dispatchMultipleActions(
      setBoard({ board: newBoard })
    );
    return data;
  } catch (err) {
    dispatchMultipleActions(
      setBoard({ board: prevBoard })
    );

    dispatch(setLoading(false));

    throw err;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function toggleStarred(filteredBoard, isStarred) {
  try {
    const { board } = store.getState().board;
    board.isStarred = !board.isStarred;
    await saveBoard(board);
    const filter = boardService.getDefaultFilterBoards();
    filter.isStarred = isStarred;
    let boards = await boardService.query(filter);
    filteredBoard.isStarred = board.isStarred;
    dispatchMultipleActions(setBoard({ board }), setFilterBoard({ filteredBoard }), setBoards({ boards }));
  } catch (err) {
    throw err;
  }
}

export async function addActivity(filteredBoard, activity) {
  try {
    const { board } = store.getState().board;

    const nextBoard = cloneDeep(board);
    nextBoard.activities = Array.isArray(nextBoard.activities) ? nextBoard.activities : [];

    if (nextBoard.activities.length >= 30) nextBoard.activities.pop();
    nextBoard.activities.unshift(activity);

    dispatchMultipleActions(
      setBoard({ board: nextBoard }),
      setFilterBoard({ filteredBoard: nextBoard })
    );

    return nextBoard.activities;
  } catch (err) {
    throw err;
  }
}

export function setFilter(filter) {
  dispatch(setFilterAction({ filter }));
}

export function setDynamicModalObj(dynamicModalObj) {
  dispatchMultipleActions(setDynamicModal({ dynamicModalObj }));
}

export function setDynamicWidth(dynamicWidth) {
  dispatchMultipleActions(setWidth({ dynamicWidth }));
}

export function setSelectedBoard(boardID) {
  dispatchMultipleActions(setSelectedBoardId({ selectedBoardId: boardID }));

}

export function closeDynamicModal() {
  const { dynamicModalObj } = store.getState().board;
  dynamicModalObj.isOpen = false;
  dispatchMultipleActions(setDynamicModal({ dynamicModalObj }));
}

export async function handleOnDragEnd(result, board) {
  if (!result?.destination) return;

  const accountId = store.getState().accounts.selectedAccount.accountId._id;
  const currentUser = store.getState().auth.currentUser;

  const byMember = {
    id: currentUser?._id,
    name: currentUser?.name
  };

  const baseGroupsIds = Array.isArray(board?.groups)
    ? board.groups.map((g) => (typeof g === "string" ? g : g?._id)).filter(Boolean)
    : [];

  const newBoard = structuredClone({ ...board, groups: baseGroupsIds });
  const allGroups = structuredClone(store.getState().groups.groups);

  // Mover grupos 
  if (result.type === "group") {
    const reorderedGroups = [...newBoard.groups];
    const [draggedGroupId] = reorderedGroups.splice(result.source.index, 1);
    reorderedGroups.splice(result.destination.index, 0, draggedGroupId);

    newBoard.groups = reorderedGroups;

    await saveBoard(newBoard);
    return;
  }

  // Mover tarefas 
  if (result.type === "task") {
    const startGroup = allGroups.find((g) => g?._id === result.source.droppableId);
    const finishGroup = allGroups.find((g) => g?._id === result.destination.droppableId);
    if (!startGroup || !finishGroup) return;

    const draggedTaskId = result.draggableId;

    // índice real dentro do array canônico do grupo
    const startIndex = Array.isArray(startGroup.tasks)
      ? startGroup.tasks.indexOf(draggedTaskId)
      : -1;

    if (startIndex === -1) return;

    // Move entre grupos
    if (startGroup._id !== finishGroup._id) {
      startGroup.tasks.splice(startIndex, 1);
      finishGroup.tasks.splice(result.destination.index, 0, draggedTaskId);

      try {
        const { task, fromGroup, toGroup } = await groupService.moveTaskToAnotherGroup(
          accountId,
          draggedTaskId,
          startGroup._id,
          finishGroup._id,
          result.destination.index,
          byMember
        );

        dispatchMultipleActions(
          updateGroupReducer({ group: fromGroup }),
          updateGroupReducer({ group: toGroup }),
          updateGroupTask({ task }),
          moveTaskBetweenGroupsOptimistic({
            task,
            fromGroupId: fromGroup._id,
            toGroupId: toGroup._id,
          })
        );
      } catch (e) {
        console.error(e);
      }
      return;
    }

    // Reorder no mesmo grupo
    const updated = [...startGroup.tasks];
    updated.splice(startIndex, 1);
    updated.splice(result.destination.index, 0, draggedTaskId);
    startGroup.tasks = updated;

    dispatchMultipleActions(updateGroupReducer({ group: startGroup }));
    try {
      await updateGroup(startGroup);
    } catch (e) {
      console.error(e);
    }
  }
}

export async function updateAndSyncTitle(obj, prevDesktops) {
  try {
    const accountId = store.getState().accounts.selectedAccount.accountId._id

    const data = await boardService.updateAndSyncTitle(obj, accountId);
    const updatedDesktops = utilService.updateItemInList(prevDesktops, data.desktop);

    data.isFolder ? (
      dispatchMultipleActions(
        setSelectedDesktop({ selectedDesktop: data.desktop }),
        setDesktops(updatedDesktops)
      )
    ) : (
      dispatchMultipleActions(
        setBoard({ board: data.board }),
        setFilterBoard({ filteredBoard: data.board }),
        setSelectedDesktop({ selectedDesktop: data.desktop }),
        setDesktops(updatedDesktops)
      )
    )

    return data
  } catch (err) {
    throw err;
  }
}

export function resetSelectedBoardId() {
  try {
    dispatchMultipleActions(
      clearBoards()
    );
    //console.log("selectedBoardId e board resetados com sucesso!");
  } catch (error) {
    console.error('Erro ao resetar o boardId:', error);
  }
}
export function resetDynamicFilter() {
  try {
    dispatchMultipleActions(
      clearFilterDynamic()
    );
    //console.log("selectedBoardId e board resetados com sucesso!");
  } catch (error) {
    console.error('Erro ao resetar o filtros dynamicos:', error);
  }
}

export async function applyBoardFilter(filter, groupIds = []) {
  try {
    dispatch(setFilterAction({ filter }));

    const requests = groupIds.map(async (groupId) => {
      const { tasks, allTaskIds, group } = await taskService.getTasksByGroup(groupId, filter);
      dispatch(setTasks({ groupId, tasks, allTaskIds, group }));
    });

    await Promise.all(requests);
  } catch (err) {
    console.error('Erro ao aplicar filtro e recarregar tasks:', err);
    throw err;
  }
}

// private functions
function _updateTask(filteredBoard, groupId, saveTask) {
  const updatedFilteredBoard = cloneDeep(filteredBoard)
  const group = updatedFilteredBoard.groups.find(currGroup => currGroup._id === groupId);
  group.tasks = group.tasks.map(task => task._id === saveTask._id ? saveTask : task);
}

